"use strict";
exports.__esModule = true;
exports.Persona = void 0;
var Persona = /** @class */ (function () {
    function Persona(version, industry, organisation, organisation_website, role, organisation_size, referral) {
        if (version === void 0) { version = 1; }
        this.version = version;
        this.industry = industry;
        this.organisation = organisation;
        this.organisation_website = organisation_website;
        this.role = role;
        this.organisation_size = organisation_size;
        this.referral = referral;
    }
    Persona.fromJSON = function (json) {
        var persona = new Persona(1, '', '', '', '', '', '');
        if (json) {
            persona.version = json.version ? json.version : 1;
            persona.industry = json.industry ? json.industry : '';
            persona.organisation = json.organisation ? json.organisation : '';
            persona.organisation_website = json.organisation_website ? json.organisation_website : '';
            persona.role = json.role ? json.role : '';
            persona.organisation_size = json.organisation_size ? json.organisation_size : '';
            persona.referral = json.referral ? json.referral : '';
        }
        return persona;
    };
    return Persona;
}());
exports.Persona = Persona;
